var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candela-component"},[_c('v-card',{class:[_vm.bg_color,
    "pa-2 ma-1 d-flex flex-grow-1",
    "justify-space-between align-center"
    ],attrs:{"outlined":true}},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex justify-space-between"},[_c('div',{class:[_vm.text_style, (_vm.text_color + "--text")]},[_vm._v(" "+_vm._s(_vm.formatted_value)+" ")])]),_c('div',{class:[
          (_vm.text_color + "--text d-flex align-center"),
            "overline font-weight-bold"
          ]},[_vm._v(_vm._s(_vm.title)+" ")])]),(_vm.icon)?_c('candela-icon',{class:(_vm.text_color + "--text"),style:({opacity: 0.4}),attrs:{"name":_vm.icon,"icon_props":{"large": true}}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }